<template>
  <div v-if="isVisible">
    <div v-if="showFieldTitle" class="field__inner-title mb-3">
      <div>{{ schema.title }}</div>
      <p v-if="schema.help">{{ schema.help }}</p>
    </div>

    <v-menu
      v-model="datePickerModal"
      :close-on-content-click="false"
      transition="scale-transition"
      offset-y
      min-width="290"
    >
      <template #activator="{ on }">
        <div v-on="isDisabled ? {} : on">
          <v-text-field
            :value="displayValue"
            :readonly="!schema.dateEditable"
            :disabled="isDisabled"
            :label="fieldLabel"
            :placeholder="fieldPlaceholder"
            :class="fieldClasses"
            :rules="rules"
            :clearable="!isDisabled"
            persistent-hint
            v-mask="'####-##-##'"
            @input="updateValue"
          />
        </div>
      </template>

      <v-date-picker
        :value="displayValue"
        color="primary"
        no-title
        :min="schema.min"
        :max="schema.max"
        @input="updateValue"
      />
    </v-menu>
  </div>
</template>

<script>
import GenericField from './GenericField';
import { mask } from 'vue-the-mask';
import { format, fromUnixTime, parseISO, getUnixTime } from 'date-fns';

const DATE_FORMAT = 'yyyy-MM-dd';

export default {
  name: 'DateField',
  mixins: [GenericField],
  directives: {
    mask,
  },
  data() {
    return {
      datePickerModal: false,
    };
  },
  computed: {
    showFieldTitle() {
      if (!this.showTitle) {
        return false;
      }

      const { placeholder, title } = this.schema || {};

      // When no explicit placeholder, title is shown inside the input instead
      if (!placeholder && title) {
        return false;
      }

      return true;
    },

    fieldPlaceholder() {
      const { hideLabel, placeholder, label, title, dateEditable } =
        this.schema || {};

      if (placeholder) {
        return placeholder;
      }

      if (hideLabel) {
        return label || title || 'YYYY-MM-DD';
      }

      if (dateEditable) {
        return 'YYYY-MM-DD';
      }

      return '';
    },

    fieldLabel() {
      if (this.showFieldTitle) {
        return '';
      }

      const { label, title } = this.schema || {};

      return label || title || 'Date';
    },

    displayValue() {
      if (!this.value) return null;

      if (this.isTimestamp(this.value)) {
        const seconds =
          this.value > 9999999999 ? Math.floor(this.value / 1000) : this.value;

        return format(fromUnixTime(seconds), DATE_FORMAT);
      }

      return this.value;
    },
  },
  methods: {
    isTimestamp(value) {
      const num = Number(value);
      return !isNaN(num) && num > 946684800;
    },

    updateValue(val) {
      this.datePickerModal = false;
      this.emitValue(this.normalizeOutput(val));
    },

    normalizeOutput(value) {
      if (!value) return value;

      if (this.isTimestamp(this.value)) {
        return getUnixTime(parseISO(value));
      }

      return value;
    },

    emitValue(value) {
      this.item ? this.save(value) : this.$emit('input', value);
    },
  },
};
</script>
